import StsLink from './sts-link.model';

export default class StsFooterModel {
  logo: string = "";
  socialLinks: StsLink[] = [];
  links: StsLink[] = [];
}
